import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { CheckoutPaymentInformationState, SelectPaymentMethod, ShoppingCartPaymentState } from '@platform-frontend/checkout';
import { DeletePaymentMethod, PaymentMethodInfo } from '@platform-frontend/marketplace';
import { ClearNotifications, Navigate, tapNextOrError } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { PaymentIdWithCallback } from '../../commercial-common/payment-id-with-callback';

@UntilDestroy()
@Component({
  selector: 'yat-payment-method-selection',
  templateUrl: './payment-method-selection.component.html',
  styleUrls: ['./payment-method-selection.component.scss']
})
export class PaymentMethodSelectionComponent {
  constructor(private activatedRoute: ActivatedRoute, private store: Store) {}

  @Select(ShoppingCartPaymentState.selectedPaymentMethod)
  selectedPaymentMethod$: Observable<PaymentMethodInfo | null>;

  @Select(CheckoutPaymentInformationState.paymentMethods)
  paymentMethods$: Observable<PaymentMethodInfo[]>;

  saveSelectedPaymentMethod({ identifier, completeCallback }: PaymentIdWithCallback): void {
    this.store
      .dispatch(new SelectPaymentMethod(identifier))
      .pipe(
        switchMap(() => this.store.dispatch(new ClearNotifications())),
        tapNextOrError(() => completeCallback()),
        untilDestroyed(this)
      )
      .subscribe();
  }

  deletePaymentMethod({ identifier, completeCallback }: PaymentIdWithCallback): void {
    this.store
      .dispatch(new DeletePaymentMethod(identifier))
      .pipe(
        tapNextOrError(() => completeCallback()),
        switchMap(() => this.navigateAfterDeletionOfLastPaymentMethod()),
        untilDestroyed(this)
      )
      .subscribe();
  }

  private navigateAfterDeletionOfLastPaymentMethod(): Observable<any> {
    return this.paymentMethods$.pipe(
      take(1),
      switchMap(paymentMethods =>
        paymentMethods.length > 0 ? of(null) : this.store.dispatch(new Navigate(['../overview'], { relativeTo: this.activatedRoute }))
      )
    );
  }
}
